"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useModalPortal2 = _interopRequireDefault(require("../../../shared/hooks/useModalPortal"));

var _Notifications = _interopRequireDefault(require("../../Notifications/Notifications"));

var _Box = _interopRequireDefault(require("../../Box/Box"));

var _Modal = _interopRequireDefault(require("../../Modal/Modal"));

var _Button = _interopRequireDefault(require("../../Button/Button"));

var _ModalContext = require("./ModalContext");

require("./Notifications.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
Notifications modal for header bar, for mobile breakpoints
*/
function NotificationsModal(_ref) {
  var emptyMessage = _ref.emptyMessage,
      title = _ref.title,
      trigger = _ref.trigger,
      items = _ref.items,
      footer = _ref.footer,
      onToggle = _ref.onToggle;
  var modalContext = (0, _react.useContext)(_ModalContext.ModalContext);
  var open = modalContext.open,
      openUI = modalContext.openUI,
      closeUI = modalContext.closeUI;

  var _useModalPortal = (0, _useModalPortal2["default"])(),
      renderNode = _useModalPortal.renderNode;

  var handleOpen = (0, _react.useCallback)(function () {
    onToggle(true);
    openUI();
  }, [onToggle, openUI]);
  var handleClose = (0, _react.useCallback)(function () {
    onToggle(false);
    closeUI();
  }, [onToggle, closeUI]);

  var itemsWithContext = _react["default"].Children.map(items, function (child) {
    if (!_react["default"].isValidElement(child)) {
      return null;
    }

    return _react["default"].cloneElement(child, {
      closeUI: modalContext.closeUI
    });
  });

  var footerWithContext = _react["default"].Children.map(footer, function (child) {
    if (!_react["default"].isValidElement(child)) {
      return null;
    }

    return _react["default"].cloneElement(child, {
      closeUI: modalContext.closeUI
    });
  });

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    tertiary: true,
    onClick: handleOpen
  }, trigger), open && /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    fullWidth: true,
    renderNode: renderNode,
    className: "st_notifications_modal",
    showDismiss: false,
    onDismiss: handleClose
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"].Title, {
    className: "st_notifications_modalheader"
  }, title, /*#__PURE__*/_react["default"].createElement(_Modal["default"].Dismiss, {
    onClick: handleClose
  })), /*#__PURE__*/_react["default"].createElement(_Box["default"].Content, {
    padding: {
      all: 'none'
    },
    className: "st_notifications_modal__list"
  }, /*#__PURE__*/_react["default"].createElement(_Notifications["default"], {
    emptyMessage: emptyMessage
  }, itemsWithContext)), footerWithContext));
}

NotificationsModal.propTypes = {
  /** message to display when there are no notifications */
  emptyMessage: _propTypes["default"].string,

  /** title for box */
  title: _propTypes["default"].string,

  /** trigger for notifications modal */
  trigger: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,

  /** notification items to display */
  items: _propTypes["default"].node,

  /** notifications footer to display */
  footer: _propTypes["default"].node,

  /** what to do when modal is opened or closed, returns final open state */
  onToggle: _propTypes["default"].func
};
NotificationsModal.defaultProps = {
  title: 'Notifications',
  emptyMessage: null,
  items: null,
  footer: null,
  onToggle: function onToggle() {
    return null;
  }
};
NotificationsModal.displayName = 'HeaderBar.Notifications.Modal';
var _default = NotificationsModal;
exports["default"] = _default;